import { render, staticRenderFns } from "./PickupConfirm.vue?vue&type=template&id=3c0a2cc7&scoped=true"
import script from "./PickupConfirm.vue?vue&type=script&lang=ts"
export * from "./PickupConfirm.vue?vue&type=script&lang=ts"
import style0 from "./PickupConfirm.vue?vue&type=style&index=0&id=3c0a2cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0a2cc7",
  null
  
)

export default component.exports